import PropTypes from 'prop-types';

const formShape = PropTypes.shape({
  control: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
});

export default formShape;
